<template>
  <div class="selling" v-if="restaurant && restaurant.top_selling_brand_items">
    <div
      class="selling__content | d-flex align-items-center justify-content-between mb-4"
    >
      <div v-if="restaurant.top_selling_brand_items.length">
        <h4>Top Selling Items</h4>
      </div>
    </div>
    <div class="selling__grid">
      <router-link
        :to="{ name: 'vendor', params: { restaurant_name: restaurant.slug } }"
        class="selling__box"
        v-for="(item, index) in restaurant.top_selling_brand_items"
        :key="index"
      >
        <img :src="item.image" :alt="item.item_name" v-if="item.image" />
        <img src="../assets/images/no_item.png" :alt="item.item_name" v-else />
      </router-link>
    </div>
  </div>
</template>

<script>
import HomeTitle from "@/components/HomeTitle.vue";

export default {
  components: {
    HomeTitle,
  },
  props: ["restaurant"],
};
</script>

<style scoped>
.selling__grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
}

.selling__box {
  display: block;
}

.selling__box img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
}

@media (max-width: 991px) {
  .selling__grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }
}

@media (max-width: 767px) {
  .selling__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
}
</style>